// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2dZ6T","modalFooterButton":"ModalNotes_modalFooterButton__1rKtc"};